<template>
	<div class="w-100 p-3 bg-white border-15 overflow-auto">
		<table class="table">
			<tr class="border">
				<td id="dsc" class="bMikhak p-3 text-center">عکس</td>
				<td id="href" class="bMikhak p-3 text-center">لینک</td>
				<td id="status" class="bMikhak p-3 text-center">وضعیت</td>
			</tr>
			<tr v-for="(f, i) in flds.content" :key="i">
				<td class="text-center">
					<img 
					:src="require('../../assets/img/'+f.dsc)"
					width="50"
					/>
					{{ f.dsc }}
				</td>
				<td dir="ltr" class="">
					{{f.href}}
				</td>
				<td>
					<selectInput 
					label="وضعیت"
					:show_label="false"
					:flds="[
						{'id': '1','name': 'فعال'},
						{'id': '2','name': 'پیش‌فرض'},
						{'id': '0','name': 'غیرفعال'}
					]"
					:value="f.status"
					@inputTxtFunc="(e)=>{set_status(f.id, e)}"
					/>
				</td>
			</tr>
		</table>
		<br/>
		<br/>
		<div class="w-100" style="display: flex; align-items: center; justify-content: center;">
			<pageNavigation :page="flds.curPage" :pages="flds.totalPages" @setPage="setPage"  />
		</div>
	</div>
</template>

	<script>
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import selectInput from  "../../UI/input/selectInput.vue";
		import { error, success, loading } from  "../../assets/library/messege.js";

		export default {
			name: 'teachers_part1',
			data(){
				return {
					error: error,
					success: success,
					loading: loading,
				}
			},
			components: {
				pageNavigation,
				selectInput,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(){

			},
			methods:{
				set_status(id, status, THIS=this){
					window.$.post(window.baseurl+'settings/' + id, {
						token: this.$localStorage.get("user"),
						role: this.$localStorage.get('user').username.role,
						mod: 'status',
						value: status,
					}, function(D){
						if(D.ok==true){
							THIS.success(THIS);
						}
					}, "json");
				},
			}
		}
	</script>
<style>

</style>
